var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlyingBricks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1438,
    height: 1260,
    viewBox: "0 0 1438 1260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.988 203.239L137.893 213.784L141.583 222.918L127.231 228.717L123.541 219.583L97.4458 230.127L101.136 239.261L86.7836 245.061L83.0935 235.927L56.9983 246.471L60.6884 255.605L54.1646 258.241L75.2509 310.437L195.289 261.934L174.202 209.737L167.679 212.374L163.988 203.239Z",
    fill: "#FFD500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.618 297.189L521.505 269.469L511.804 267.758L514.247 253.898L523.948 255.609L528.836 227.889L519.135 226.178L520.357 219.248L464.923 209.473L450.261 292.633L505.695 302.408L506.917 295.478L516.618 297.189Z",
    fill: "#004A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.755 194.746L891.978 169.667L900.755 165.194L893.727 151.4L884.95 155.873L872.173 130.793L880.95 126.32L873.922 112.527L865.146 116.999L852.368 91.9194L861.145 87.4468L854.118 73.653L845.341 78.1255L832.563 53.0458L841.34 48.5732L838.785 43.5573L888.939 17.9998L966.881 170.986L916.727 196.544L913.532 190.274L904.755 194.746Z",
    fill: "#00963E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1289.33 12.5147L1261.46 16.4321L1262.83 26.1879L1247.5 28.3425L1246.13 18.5867L1218.26 22.5041L1219.63 32.2599L1204.3 34.4145L1202.93 24.6587L1175.06 28.5761L1176.43 38.3319L1169.46 39.3112L1177.3 95.0586L1305.5 77.0386L1297.67 21.2912L1290.7 22.2705L1289.33 12.5147Z",
    fill: "#004A80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.173 514.78L128.789 501.134L124.013 492.518L136.321 485.695L141.097 494.311L165.713 480.665L160.937 472.048L167.091 468.637L139.801 419.4L65.9541 460.339L93.2436 509.575L99.3975 506.164L104.173 514.78Z",
    fill: "#E3000B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.196 497.208L457.261 500.639L458.461 510.417L443.097 512.304L441.897 502.525L413.962 505.956L415.163 515.734L399.798 517.621L398.598 507.842L370.663 511.273L371.864 521.051L356.5 522.938L355.299 513.159L327.364 516.59L328.565 526.368L321.581 527.226L328.441 583.101L498.843 562.176L491.983 506.301L486.396 506.987L485.196 497.208Z",
    fill: "#00963E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.001 626.066L699.277 615.979L695.746 606.782L710.198 601.234L713.728 610.431L740.003 600.344L736.473 591.147L750.924 585.599L754.454 594.796L780.73 584.709L777.199 575.512L783.768 572.99L763.596 520.434L642.73 566.835L662.902 619.391L669.471 616.869L673.001 626.066Z",
    fill: "#00963E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1128.51 222.534L1104.64 237.45L1109.86 245.805L1096.73 254.009L1091.51 245.654L1067.65 260.57L1072.87 268.925L1059.74 277.128L1054.52 268.774L1030.65 283.69L1035.87 292.044L1022.74 300.248L1017.52 291.893L993.655 306.809L998.875 315.164L992.908 318.893L1022.74 366.634L1168.33 275.647L1138.5 227.906L1133.73 230.889L1128.51 222.534Z",
    fill: "#EE7500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M774.139 244.323L783.706 270.794L774.442 274.143L779.704 288.702L788.968 285.353L798.535 311.825L789.271 315.174L794.533 329.733L803.797 326.384L813.364 352.856L804.1 356.204L809.362 370.764L818.626 367.415L828.193 393.886L818.929 397.235L820.843 402.529L767.906 421.666L709.546 260.19L762.483 241.054L764.875 247.671L774.139 244.323Z",
    fill: "#AFCA00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1292.64 527.931L1319.09 537.558L1322.46 528.301L1329.07 530.708L1348.32 477.807L1226.67 433.523L1207.42 486.423L1214.03 488.83L1210.66 498.088L1237.11 507.715L1240.47 498.457L1255.02 503.752L1251.65 513.009L1278.1 522.636L1281.47 513.379L1296.01 518.674L1292.64 527.931Z",
    fill: "#F5B4D2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1432 773.951L27.5596 754.755L34.2776 747.55L22.9567 736.992L16.2386 744.197L-4.34503 725L2.37305 717.795L-8.94793 707.237L-15.666 714.442L-36.2496 695.245L-29.5315 688.04L-40.8525 677.482L-47.5706 684.687L-68.1542 665.491L-61.4361 658.285L-65.5528 654.446L-27.1638 613.274L98.3962 730.374L60.0071 771.546L54.8612 766.746L48.1432 773.951Z",
    fill: "#00963E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.834 663.264L431.496 688.563L440.349 692.882L433.564 706.796L424.71 702.478L412.372 727.777L421.226 732.095L414.44 746.01L405.587 741.691L393.249 766.99L402.102 771.309L395.317 785.223L386.463 780.904L374.125 806.203L382.979 810.522L379.894 816.847L430.487 841.525L505.747 687.201L455.155 662.523L452.687 667.583L443.834 663.264Z",
    fill: "#0098D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.637 732.828L1012.01 718.754L1007.09 710.222L1020.49 702.482L1025.42 711.014L1049.79 696.94L1044.87 688.408L1058.27 680.667L1063.2 689.199L1087.57 675.125L1082.64 666.594L1096.05 658.853L1100.98 667.385L1125.35 653.311L1120.42 644.779L1126.52 641.261L1098.37 592.508L949.692 678.358L977.837 727.111L982.712 724.296L987.637 732.828Z",
    fill: "#FFD500"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1318.25 807.755L1296.07 825.084L1302.13 832.847L1296.59 837.18L1331.24 881.541L1364.51 855.547L1329.85 811.185L1324.31 815.518L1318.25 807.755Z",
    fill: "#2CAFE5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.436 77.1203L414.671 61.2369L409.113 53.1036L414.922 49.1327L383.158 2.65663L348.305 26.4817L380.069 72.9578L385.877 68.9869L391.436 77.1203Z",
    fill: "#EE7500"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.363 1080.82L157.034 1057.22L148.773 1062.58L144.941 1056.68L97.7328 1087.34L168.244 1195.93L215.452 1165.27L211.62 1159.37L219.882 1154L204.553 1130.4L196.292 1135.76L187.861 1122.78L196.122 1117.41L180.794 1093.81L172.532 1099.17L164.102 1086.19L172.363 1080.82Z",
    fill: "#004A80"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.388 1009.89L298.536 982.362L308.171 980.314L305.246 966.547L295.61 968.596L289.759 941.063L299.394 939.015L297.931 932.132L352.99 920.427L370.545 1003.02L315.486 1014.73L314.023 1007.85L304.388 1009.89Z",
    fill: "#E3000B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M752.204 907.697L735.661 884.925L743.63 879.135L735.359 867.749L727.389 873.539L710.846 850.768L718.816 844.977L714.68 839.284L760.219 806.194L809.848 874.51L764.309 907.6L760.173 901.907L752.204 907.697Z",
    fill: "#FFD500"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1057.7 939.961L1041.97 916.625L1050.13 911.116L1042.26 899.449L1034.1 904.958L1018.36 881.622L1026.53 876.113L1022.59 870.279L1069.26 838.799L1116.47 908.806L1069.81 940.286L1065.87 934.452L1057.7 939.961Z",
    fill: "#004A80"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1322.46 1135.63L1294.66 1131.23L1293.12 1140.96L1286.17 1139.86L1277.36 1195.46L1405.23 1215.71L1414.04 1160.11L1407.09 1159.01L1408.63 1149.28L1380.83 1144.88L1379.29 1154.61L1364 1152.19L1365.54 1142.46L1337.74 1138.05L1336.2 1147.78L1320.91 1145.36L1322.46 1135.63Z",
    fill: "#00963E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.593 1305.2L363.89 1292.86L359.571 1284L373.484 1277.22L377.802 1286.07L403.099 1273.73L398.78 1264.88L412.693 1258.09L417.011 1266.95L442.308 1254.61L437.989 1245.75L451.902 1238.97L456.22 1247.82L481.517 1235.48L477.198 1226.63L483.522 1223.54L458.847 1172.94L304.54 1248.21L329.216 1298.81L334.275 1296.34L338.593 1305.2Z",
    fill: "#DE007D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M707.69 1244.03L685.817 1261.75L692.017 1269.4L686.548 1273.83L721.972 1317.58L754.781 1291.01L719.357 1247.26L713.889 1251.69L707.69 1244.03Z",
    fill: "#004A80"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1127.81 1227.05L1134.62 1199.74L1125.06 1197.35L1128.8 1182.33L1138.36 1184.71L1145.17 1157.4L1135.61 1155.02L1139.36 1140L1148.91 1142.38L1155.72 1115.07L1146.17 1112.69L1149.91 1097.66L1159.47 1100.05L1166.28 1072.74L1156.72 1070.35L1158.42 1063.53L1103.8 1049.91L1062.27 1216.51L1116.89 1230.13L1118.25 1224.66L1127.81 1227.05Z",
    fill: "#EE7500"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.223 1101.11L572.336 1073.39L582.037 1071.68L579.349 1056.44L569.648 1058.15L564.761 1030.43L574.462 1028.72L571.774 1013.47L562.073 1015.18L557.186 987.46L566.886 985.75L564.198 970.503L554.498 972.214L549.61 944.494L559.311 942.783L558.334 937.239L613.768 927.464L643.58 1096.56L588.146 1106.33L586.924 1099.4L577.223 1101.11Z",
    fill: "#AFCA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlyingBricks);
export default __webpack_public_path__ + "static/media/flyingBricks.b57466aabb7de25a5330853084732a55.svg";
export { ForwardRef as ReactComponent };